import styled from 'styled-components';

import { LogoutIcon, NavProfileIcon } from '../../../assets';
import { ThemeProp } from '../../../theme/Themes';

export const Container = styled.div`
  width: 12.938rem;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0.5rem;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 0.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  height: 2.5rem;
  gap: 0.75rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  min-width: unset;
  color: ${(props: ThemeProp) => props.theme.colors.content.default};

  &:hover {
    background: ${(props: ThemeProp) => `${props.theme.colors.main.c050}`};
  }
`;

export const StyledUserProfileIcon = styled(NavProfileIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.content.default};
  width: 1.25rem;
  height: 1.25rem;
`;

export const StyledLogoutIcon = styled(LogoutIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.content.default};
`;

export const LogoutModalContainer = styled.div`
  padding: 0 0.5rem;
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
  text-align: left;
`;
